// 错误弹窗
import Vue from 'vue'
export function confirmError(message) {
    console.log(message)
    Vue.prototype.$confirm(message, {
        confirmButtonText: '确定',
        showCancelButton: false, //是否显示取消按钮
        closeOnClickModal: false, //是否点击遮罩（点击空白处）关闭
        showClose: false, //是否显示右上角的x
        type: 'error'
      }).then(() => {

      })
}
export default {
    confirmError,
}
